import { Component, Input } from '@angular/core';

import { ApptFormService } from './appt-form.service';

@Component({
  selector: 'appt-form',
  template: require('./appt-form.component.html'),
  styles: [require('./appt-form.component.scss')],
  providers: [ApptFormService]
})
export class ApptFormComponent {

  @Input()
  set type(emailType: string) {
    this.service.setType(emailType);
  }

  constructor(private service: ApptFormService) {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/appt-form/appt-form.component.ts